import React from "react";
import GridControls from "./GridControls/GridControls";

import { GridContainer, PatternsContainer } from "./GridStyles";
import DetectedPatterns from "./DetectedPatterns/DetectedPatterns";
import { useSelectedPatternData } from "./hooks/useSelectedPatternData";

export default function Grid() {
  const selectedPatternData = useSelectedPatternData();

  return (
    <GridContainer>
      <GridControls selectedPatternData={selectedPatternData} />

      <PatternsContainer>
        <DetectedPatterns selectedPatternData={selectedPatternData} />
      </PatternsContainer>
    </GridContainer>
  );
}
